module.exports = __webpack_public_path__ + "static/media/sedan-avatar.8bf3d4c5.svg";